import React from 'react';
import classNames from 'classnames';
import { Box, IconNewWindow } from 'braid-design-system';
import { NavLink } from 'react-router-dom';

import useMetrics from '../../../../../../../hooks/useMetrics';
import { globalActions } from '../../../../../../../metrics/actions';

import * as styles from './MenuLink.css';

interface Props {
  href: string | null;
  hasCreditsMetricsEvent?: boolean;
  isExternal?: boolean;
  isLast: boolean;
  onClick?: (event: any) => void | Promise<void>;
  isActive?: (match: any, location: any) => boolean;
  children: React.ReactNode;
}

const MenuLink = ({
  href,
  hasCreditsMetricsEvent,
  isExternal,
  onClick,
  isActive,
  isLast,
  children,
}: Props) => {
  const { sendCreditsDashboardEvent } = useMetrics({
    sendCreditsDashboardEvent: globalActions.credits,
  });

  const handleOnClick = () => {
    if (hasCreditsMetricsEvent) {
      sendCreditsDashboardEvent();
    }
  };

  if (href === null) {
    return (
      <span
        className={classNames({
          [styles.last]: isLast,
        })}
      >
        <Box>{children}</Box>
      </span>
    );
  }

  // External link
  if (isExternal) {
    return (
      <Box
        className={{
          [styles.isSelected]: isActive,
          [styles.last]: isLast,
        }}
        marginRight="medium"
        display="inlineBlock"
      >
        <Box
          component="a"
          href={href}
          target="_blank"
          rel="noopener"
          className={'navlink-menu'}
          onClick={handleOnClick}
        >
          <Box display="flex" alignItems="center">
            {children}
            <Box paddingLeft="small" paddingBottom="xxsmall">
              <IconNewWindow size="xsmall" />
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      className={classNames({
        [styles.isSelected]: isActive,
        [styles.last]: isLast,
      })}
      marginRight="medium"
      display="inlineBlock"
    >
      <NavLink
        to={href}
        {...(onClick ? { onClick } : null)}
        {...(isActive ? { isActive } : null)}
        className={'navlink-menu'}
        activeClassName={'active-navlink-menu'}
      >
        {children}
      </NavLink>
    </Box>
  );
};

MenuLink.defaultProps = {
  isLast: false,
};

export default MenuLink;
